var map = {
	"./57_legs.mp3": "a8f5",
	"./58_hands.mp3": "d2f6",
	"./59_head.mp3": "44b0",
	"./60_tummy.mp3": "ee55",
	"./61_stretch.mp3": "a78f",
	"./62_shake.mp3": "584e",
	"./63_pat.mp3": "5a34",
	"./64_hat.mp3": "3488",
	"./65_T-shirt.mp3": "bfa0d",
	"./66_dress.mp3": "1113",
	"./67_jumper.mp3": "060b",
	"./68_jacket.mp3": "288a",
	"./69_shoes.mp3": "95bb",
	"./70_jeans.mp3": "735d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a4a8";